import { CommonModule } from '@angular/common';
import { inject } from '@angular/core';
import { UiLoadingIndicatorComponent } from '@common/ui/frontend-shared/loading-indicator';
import { AccessState } from '@core/frontend-shared';
import { Store } from '@ngxs/store';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common";
export let CoreLoginOverlayComponent = /*#__PURE__*/(() => {
  class CoreLoginOverlayComponent {
    constructor() {
      this.accessIsReady$ = inject(Store).select(AccessState.isReady);
    }
    static {
      this.ɵfac = function CoreLoginOverlayComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CoreLoginOverlayComponent)();
      };
    }
    static {
      this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
        type: CoreLoginOverlayComponent,
        selectors: [["core-login-overlay"]],
        decls: 2,
        vars: 3,
        consts: [["label", "Login wird durchgef\u00FChrt...", 3, "loading"]],
        template: function CoreLoginOverlayComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelement(0, "ui-loading-indicator", 0);
            i0.ɵɵpipe(1, "async");
          }
          if (rf & 2) {
            i0.ɵɵproperty("loading", !i0.ɵɵpipeBind1(1, 1, ctx.accessIsReady$));
          }
        },
        dependencies: [CommonModule, UiLoadingIndicatorComponent, i1.AsyncPipe],
        encapsulation: 2
      });
    }
  }
  return CoreLoginOverlayComponent;
})();